import { render, staticRenderFns } from "./ScheduleCrud.vue?vue&type=template&id=28dbad95&"
import script from "./ScheduleCrud.vue?vue&type=script&lang=js&"
export * from "./ScheduleCrud.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleCrud.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports